<template>
  <div class="plain-text padding--bottom-1" v-if="textData">
    <div class="row">
      <div class="col-12">
        <h3 v-if="textData.headline" v-text="textData.headline"/>
        <div v-if="textData.text && textData.text.html" v-html="textData.text.html"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'PlainText',
  props: {
    id: String,
    dataObj: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      textData: null
    };
  },
  methods: {
    async fetchModuleText () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=moduleText&id=${this.id}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.textData = response.moduleText;
        });
    }
  },
  created () {
    if (this.id) {
      this.fetchModuleText();
    }
    if (this.dataObj !== null) {
      this.textData = this.dataObj;
    }
  }
};
</script>

<style lang="scss">
  .plain-text {
    h3 {
      margin-bottom: $gap * 2;
    }
    h4 {
      font-size: 18px;
      text-transform: none;
    }
    p {
      margin-bottom: $gap * 1.5;
    }
    li div p {
      margin: 0;
    }
  }
</style>
